import { InviteStatusEnum } from './IInvitations';

export default interface INotification {
  status: number;
  id: string;
  type: NotificationType;
  message?: string;
  user?: {
    email: string;
    id: string;
    name: string;
  };
  details: Record<string, string> & {
    invite_id?: string;
    room_id: string;
    send_by: string;
    user_email: string;
    group_name: string;
    room_name: string;
    invite_status?: InviteStatusEnum;
  };
  created_at: string;
  link?: string;
};

export interface INotificationV2 {
  root: INotification[];
  pagination: {
    pages: number;
    current: number;
    per_page: number;
    total: number;
  };
};

export enum ChatNotificationsEnum {
  ROOM_CHAT = 'room_chat',
  NEW_MESSAGE = 'new_message',
}

export enum RoomNotificationsEnum {
  NDA_ENABLE = 'nda_enable',
  UPDATE_USER_PERMISSIONS = 'update_user_permissions',
  DELETE_ROOM = 'delete_room',
  TARIFF_EXPIRED = 'tariff_expired',
  UPDATE_ROLE = 'update_role',
  BLOCK_USER_BY_ROOM = 'block_user_by_room',
  UNBLOCK_USER_BY_ROOM = 'unblock_user_by_room',
  NDA_SIGNED = 'nda_signed',
  CHANGE_ROOM_NAME = 'change_room_name',
  UPDATE_ROLE_PERMISSION = 'update_role_permission',
};

export enum InviteNotificationsEnum {
  INVITE = 'invite',
  INVITE_REMINDER = 'invite_reminder',
}

export enum AgreementNotificationsEnum {
  AGREEMENT_INITIATED = 'agreement_initiated',
  DECLINE_AGREEMENT = 'decline_agreement',
  DELETE_AGREEMENT = 'delete_agreement',
  FINALIZE_AGREEMENT = 'finalize_agreement',
}

export enum SigningNotificationsEnum {
  CANCELING_THE_SIGNING = 'canceling_the_signing',
  INITIATION_OF_SIGNING = 'initiation_of_signing',
  REJECTION_SIGNING = 'rejection_signing',
  SIGNING_OF_DOCUMENT = 'signing_of_document',
  FINALIZATION_OF_SIGNATURE = 'finalization_of_signature',
}

export enum DocumentNotificationEnum {
  ADD_NOTE = 'add_note',
  CHANGE_STATUS = 'change_status',
  DELETE_FILE = 'delete_file',
  DELETE_FILE_CONFIDENTIAL = 'delete_file_confidential',
  DOWNLOAD_CONF_FILE_AS_PDF = 'download_conf_file_as_pdf',
  DOWNLOAD_FILE = 'download_file',
  DOWNLOAD_FILE_AS_PDF = 'download_file_as_pdf',
  DOWNLOAD_FILE_CONFIDENTIAL = 'download_file_confidential',
  DOWNLOAD_PDF_DOCUMENT = 'download_pdf_document',
  MOVING_A_CONF_DOCUMENT_TO = 'moving_a_conf_document_to',
  MOVING_A_DOCUMENT_TO = 'moving_a_document_to',
  MOVE_FOLDER = 'move_folder',
  UPLOAD_DOCUMENT = 'upload_document',
  UPLOAD_DOCUMENT_CONFIDENT = 'upload_document_confident',
  UPLOAD_DOCUMENT_VERSION = 'upload_document_version',
  UPLOAD_DOCUMENT_VERSION_CONFIDENTIAL = 'upload_document_version_confidential',
  CHANGE_DOCUMENT_NAME = 'change_document_name',
  UPLOAD_VIDEO = 'upload_video',
  DELETE_VIDEO = 'delete_video',
  UPLOAD_VIDEO_CONFIDENTIAL = 'upload_video_confidential',
  DELETE_VIDEO_CONFIDENTIAL = 'delete_video_confidential',
  VISIT_TEMP_LINK = 'visit_temp_link',
  START_DOCUMENT_EDITING = 'start_document_editing',
  MODIFYING_DOCUMENT = 'modifying_document',
  DELETE_DOCUMENTS_FROM_RECYCLE_BIN = 'delete_documents_from_recycle_bin',
  RESTORE_DELETED_DOCUMENTS = 'restore_deleted_documents',
  RESTORE_DELETED_DOCUMENTS_IN_ROOT = 'restore_deleted_documents_in_root',
  DELETE_FOLDERS_FROM_RECYCLE_BIN = 'delete_folders_from_recycle_bin',
  RESTORE_DELETED_FOLDERS = 'restore_deleted_folders',
  RESTORE_DELETED_FOLDERS_IN_ROOT = 'restore_deleted_folders_in_root',
  CREATE_DOCUMENT = 'create_document',
}

export enum loadingNotificationEnum {
  LOADING = 'loading'
}

export type NotificationType = SigningNotificationsEnum | loadingNotificationEnum
  | AgreementNotificationsEnum| InviteNotificationsEnum | RoomNotificationsEnum
  | DocumentNotificationEnum | ChatNotificationsEnum;
